// src/App.js
import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Section } from './components/Section';
import { Footer } from './components/Footer';

export default function App() {
  return (
    <div className="flex flex-col min-h-screen font-sans">
      <Navbar />
      <Hero />
      <main className="flex-grow">
        <Services />
        <Hero />
        <Section id="stakes" title={<>The cost to <strong>YOU</strong></>}>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
          <li>Are you confident you're not overpaying on your taxes?</li>
          <li>Do you feel certain your business is structured for maximum efficiency?</li>
          <li>Are you tired of the stress and second-guessing?</li>
          <li>How much peace of mind are you losing by living without a consultant who actually knows your situation?</li>
          </ul>
        <p className="mt-4 text-center font-semibold">
          Let’s fix that today—get in touch with Farrell CPA, PLLC.</p>
        </Section>

        <Section id="savings" title={<>What we can save <strong>YOU</strong></>}>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>Keep more of your hard-earned money</li>
            <li>Free up your time</li>
            <li>Minimize audit and compliance risk</li>
            <li>Receive personal attention that big firms can’t provide</li>
            <li>Streamline your accounting process</li>
            <li>Avoid costly mistakes and last-minute headaches once and for all</li>
          </ul>
        </Section>

      <Section id="how" title="How?">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center bg-white py-8">
    
        {/* Step 1 */}
        <div>
        <img src="/STEP1.png" alt="Get in touch" className="mx-auto mb-4 h-20 w-20" />
        <h3 className="text-xl font-semibold mb-2">1. Get in touch</h3>
        <p>Schedule a free consultation with our team—it only takes a minute.</p>
        </div>

        {/* Step 2 */}
        <div>
        <img src="/STEP2.png" alt="Talk to the pros" className="mx-auto mb-4 h-20 w-20" />
        <h3 className="text-xl font-semibold mb-2">
        2. Talk to our professionals to make a plan for <strong>you</strong>
        </h3>
        <p>We’ll learn your goals, assess your needs, and build a personalized strategy.</p>
        </div>

        {/* Step 3 */}
        <div>
        <img src="/STEP3.png" alt="Live stress-free" className="mx-auto mb-4 h-20 w-20" />
        <h3 className="text-xl font-semibold mb-2">3. Live without tax-related stress</h3>
        <p>With your taxes in expert hands, you can focus on growing your business—or just breathe easy.</p>
        </div>

      </div>
        </Section>

        <Section id="about-us" title="Our Story">
          <p>At Farrell CPA, our story is your story. We want you to feel confident and in control—whether you're managing your personal finances or running a business. What you really want is clarity, peace of mind, and the reassurance that you’re not missing deductions or overpaying on your taxes. But tax laws are complicated, and trying to navigate them alone often leads to confusion, unnecessary stress, and costly mistakes. That’s where we come in. At Farrell CPA, PLLC, we act as your personal guide—offering expert, one-on-one support tailored to your unique situation. Our plan is simple: we listen to your needs, review your finances in detail, and handle your tax preparation with precision and care—whether it's a personal return, partnership, or S corporation filing. Get in touch with us today. With our support, you can stop worrying and start focusing on growing your business, building wealth, and feeling confident about your financial future.</p>
        </Section>

      </main>
      <Footer />
    </div>
  );
}
